module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sigil_not_in_toc",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("More from Henry Kuttner")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap270022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Time Trap"), _c('br'), _vm._v("\n  Book of Iod"), _c('br'), _vm._v("\n  Elak of Atlantis"), _c('br'), _vm._v("\n  Prince Raynor"), _c('br'), _vm._v("\n  Murder of Eleanor Pope"), _c('br'), _vm._v("\n  Murder of a Mistress"), _c('br'), _vm._v("\n  Murder of a Wife"), _c('br'), _vm._v("\n  Murder of Ann Avery"), _c('br'), _vm._v("\n  The Best of Henry Kuttner"), _c('br'), _vm._v("\n  Robots Have No Tails"), _c('br'), _vm._v("\n  Ahead of Time"), _c('br'), _vm._v("\n  Earth’s Last Citadel"), _c('br'), _vm._v("\n  Mask of Circe"), _c('br'), _vm._v("\n  Man Drowning")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 66
// module chunks = 0